"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonMegaMenuLink = void 0;
const React = require("react");
const megamenu_levels_enum_1 = require("./megamenu-levels.enum");
const react_router_dom_1 = require("react-router-dom");
const BronsonMegaMenuLink = (props) => {
    var _a;
    const clickOption = () => {
        props.onCloseMenu;
        props.route.onClick && props.route.onClick();
    };
    let button;
    if (props.route.onClick) {
        const normalizedLabel = props.route.label &&
            props.route.label.toLocaleLowerCase().replace(' ', '');
        button = (React.createElement("li", { id: `menu-control-${normalizedLabel}`, onClick: clickOption },
            React.createElement("span", { className: `c-mega-menu__link c-mega-menu__link--level-${props.level ? props.level : megamenu_levels_enum_1.Levels.ONE}` },
                React.createElement("span", { className: 'o-media o-media--small o-media--middle' },
                    props.route.img ? (React.createElement("span", { className: 'o-media__img' },
                        React.createElement("i", { className: `c-mega-menu__icon c-icon c-icon--small c-icon--[${props.route.img}]` }))) : (''),
                    React.createElement("span", { className: 'o-media__body' }, props.route.label)))));
    }
    else {
        const normalizedPath = props.route.path && props.route.path.replace('/', '');
        button = (React.createElement("li", { id: `menu-control-${normalizedPath}` },
            React.createElement(react_router_dom_1.Link, { title: `Ir a ${props.route.label}`, to: (_a = props.route.path) !== null && _a !== void 0 ? _a : '', className: `c-mega-menu__link c-mega-menu__link--level-${props.level ? props.level : megamenu_levels_enum_1.Levels.ONE}`, "data-component": 'dh-mega-menu-link', onClick: props.onCloseMenu },
                React.createElement("span", { className: 'o-media o-media--small o-media--middle' },
                    props.route.img ? (React.createElement("span", { className: 'o-media__img' },
                        React.createElement("i", { className: `c-mega-menu__icon c-icon c-icon--small c-icon--[${props.route.img}]` }))) : (''),
                    React.createElement("span", { className: 'o-media__body' }, props.route.label)))));
    }
    return button;
};
exports.BronsonMegaMenuLink = BronsonMegaMenuLink;
